import {
  PATH_AB_TEST_PAGE_PERFORMANCE,
  PATH_CALL_CENTER_CALL_LEAD,
  PATH_CALL_CENTER_CLOUD_RECORDING_DETAILS,
  PATH_CALL_CENTER_JOIN,
  PATH_CALL_CENTER_JOIN_AS_ADMIN,
  PATH_CALL_CENTER_LEAD_RATE,
  PATH_EDIT_PROOF_NOTIFICATION,
  PATH_LANDING_PAGE_STATS,
  PATH_LANDING_PAGES_EDITOR_V3,
  PATH_LANDING_PAGES_PREVIEW,
  PATH_QUESTIONNAIRE_EDIT,
} from "@/routes/paths";

export const getLandingPageEditor = (pageId: string | number): string => {
  return PATH_LANDING_PAGES_EDITOR_V3.replace(":pageId", `${pageId}`);
};

export const getLandingPagePreview = (pageId: string | number): string => {
  return PATH_LANDING_PAGES_PREVIEW.replace(":pageId", `${pageId}`);
};

export const getQuestionnaireEdit = (qId: string | number): string => {
  return PATH_QUESTIONNAIRE_EDIT.replace(":questionnaireId", `${qId}`);
};

export const getLandingPageStatsUrl = (pageId: string | number): string => {
  return PATH_LANDING_PAGE_STATS.replace(":pageId", `${pageId}`);
};

export const getAbTestStatsUrl = (pageId: string | number) => {
  return PATH_AB_TEST_PAGE_PERFORMANCE.replace(":pageId", `${pageId}`);
};

export const getEditProofNotificationPath = (id: number | string) =>
  PATH_EDIT_PROOF_NOTIFICATION.replace(":notificationId", `${id}`);

//prettier-ignore
export const getJoinAsAdminUrl = (sessionName: string) => PATH_CALL_CENTER_JOIN_AS_ADMIN.replace(":sessionName", sessionName);
export const getJoinMeetingUrl = (sessionName: string) => PATH_CALL_CENTER_JOIN.replace(":sessionName", sessionName);
export const getCallLeadUrl = (sessionName: string) => PATH_CALL_CENTER_CALL_LEAD.replace(":sessionName", sessionName);

export const getRateLeadUrl = (sessionId: string) => PATH_CALL_CENTER_LEAD_RATE.replace(":sessionId", encodeURIComponent(sessionId));
export const getCloudRecordingDetailsUrl = (sessionId: string) => PATH_CALL_CENTER_CLOUD_RECORDING_DETAILS.replace(":sessionId", encodeURIComponent(sessionId));


export const getRelativePath = (basePath: string, absolutePath: string) => {
  if (!absolutePath.startsWith(basePath)) {
    throw new Error(
      `Path "${absolutePath}" does not start with basePath "${basePath}"`
    );
  }
  const relative = absolutePath.slice(basePath.length);

  return relative.startsWith("/") ? relative.slice(1) : relative;
}
